import Vue from 'vue'

const DrupalSettings = {}

DrupalSettings.install = function () {
  /**
   * Discover colors to use from parent windows drupalSettings variables.
   */
  Vue.prototype.$primaryColorFromDrupal = '#6b257d'

  if (window?.parent?.drupalSettings?.theme) {
    Vue.prototype.$primaryColorFromDrupal = window.parent.drupalSettings.theme.colors['color-one']
  }
}

Vue.use(DrupalSettings)
